import React, { useEffect, useRef, useState } from "react";
import "./BybAudit.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import bybaudit from "../../../assets/selfaudit/images/bybaudit.jpeg";
import key from "../../../assets/selfaudit/images/key.svg";
import map from "../../../assets/selfaudit/images/map.svg";
import engagement from "../../../assets/selfaudit/images/engagement.svg";
import auditline from "../../../assets/selfaudit/images/auditline.png";

gsap.registerPlugin(ScrollTrigger);

function BybAudit() {
  const videoRef = useRef(null);
  const triggerRef = useRef(null);
  const hasPlayed = useRef(false); // Track if the video has already played
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    const trigger = triggerRef.current;

    if (!video || !trigger) return;

    // Function to handle ScrollTrigger for video playback
    const handleScrollTrigger = () => {
      ScrollTrigger.create({
        trigger: trigger,
        start: "top top", // When the section hits the top of the viewport
        onEnter: () => {
          if (!hasPlayed.current) {
            video.play(); // Play the video
            hasPlayed.current = true; // Mark the video as played
          }
        },
      });
    };

    // Ensure video readiness
    if (video.readyState >= 2) {
      handleScrollTrigger();
    } else {
      video.addEventListener("loadedmetadata", handleScrollTrigger);
    }

    // Ensure the video stops naturally at its end
    const handleVideoEnd = () => {
      video.pause(); // Pause the video naturally at the end
    };

    video.addEventListener("ended", handleVideoEnd);

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      video.removeEventListener("loadedmetadata", handleScrollTrigger);
      video.removeEventListener("ended", handleVideoEnd);
    };
  }, []);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);
const [systemInfo, setSystemInfo] = useState({
    platform: "",
    userAgent: "",
    cpuCores: 0,
  });

  useEffect(() => {
    const fetchSystemInfo = () => {
      const platform = navigator.platform || 'Unknown';
      const userAgent = navigator.userAgent || 'Unknown';
      const cpuCores = navigator.hardwareConcurrency || 0; // Get number of CPU cores
      setSystemInfo({ platform, userAgent, cpuCores });
    };

    fetchSystemInfo();
  }, []);

  

  useEffect(() => {
    const detectMacArchitecture = () => {
     const check_list =   document.body.querySelector('.check_list');
     const bybAnalysis =   document.body.querySelector('.byb-analysis');
     const bybAudit =   document.body.querySelector('.byb-audit');
     const check_list_believe =   document.body.querySelector('.check_list.byb_believe');
     const panel =   document.body.querySelector('.panel.red');
     const legacy =   document.body.querySelector(' .legacy-content');

    
      const body = document.body;
      
      const { platform, cpuCores } = systemInfo;

      if (platform.includes('Win')) {
        // legacy.style.backgroundColor ="brown"
        body.style.backgroundColor = 'rgb(7 26 40)'; // Windows
        check_list.style.background ="rgb(7 26 40)"
        bybAnalysis.style.background ="rgb(7 26 40)"
        bybAudit.style.background="rgb(7 26 40)"
        check_list_believe.style.background="rgb(7 26 40)"
        panel.style.background="rgb(7 26 40)"
        legacy.style.background="rgb(7 26 40)"
        
        // check_list_believe
      }
       else if (platform.includes('Mac'))
         {  
        if (cpuCores >= 8) {
          body.style.backgroundColor = 'hwb(202.33deg 0.78% 82.35%)';
          check_list.style.background ="hwb(202.33deg 0.78% 82.35%)"
          bybAnalysis.style.background ="hwb(202.33deg 0.78% 82.35%)"
          bybAudit.style.background ="hwb(202.33deg 0.78% 82.35%)"// Mac M Series (ARM64)
          panel.style.background="hwb(202.33deg 0.78% 82.35%)"
          legacy.style.background="hwb(202.33deg 0.78% 82.35%)"

        } else {
          body.style.backgroundColor = 'hwb(204.29deg 1.18% 82.35%)'; // Mac Intel
          check_list.style.background ="hwb(204.29deg 1.18% 82.35%)"
          bybAnalysis.style.background ="hwb(204.29deg 1.18% 82.35%)"
          bybAudit.style.background ="hwb(204.29deg 1.18% 82.35%)"
          panel.style.background="hwb(204.29deg 1.18% 82.35%)"
          legacy.style.background="hwb(204.29deg 1.18% 82.35%)"

        }
      } 
   
    };

    detectMacArchitecture();
  }, [systemInfo]); // Added systemInfo as a dependency to useEffect


  return (
    <section className="byb-audit">
      <div className="container">
        {/* Header with fade-in effect */}
        <div className="byb-audit-header" ref={triggerRef}>
          <p
            ref={textRef}
            className={`fade-in-text ${isVisible ? "visible" : ""}`}
          >
            IN KIT – CUSTOMER JOURNEY MAP
          </p>
          <h1><span className="d-inline d-md-block">Every Interaction is a Step</span> Toward Brand Loyalty</h1>
        </div>

        {/* Video section */}
        <div
          className="scroll-through-hero st-hero-animate sth-fadein-off byb-toolkit"
          
        >
          <div className="scroll-through-hero-pin scroll_pin desktop_show">
            <div className="video-container">
              <video
                ref={videoRef}
                src="https://brewyourbrand.blr1.digitaloceanspaces.com/book3.webm"
                playsInline
                webkit-playsInline
                preload="metadata"
                muted
                className="video-background"
                // style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        </div>

        {/* Mobile image placeholder */}
        <img
          src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/book3.svg"
          className="show_mob w-100" width="720" height="720" loading="lazy" decoding="async"
          alt="Every Interaction"
        />

        {/* Bottom content */}
        <div className="byb-audit-bottom">
          <p>
            Identify touchpoints, learn what it takes to build{" "}
            <span style={{ color: "white" }}>better brand experiences,</span>{" "}
            and foster stronger connections with the Customer Journey Map.
          </p>

          <div className="byb-audit-bottom-down">
            <div className="key-para">
              <img src={auditline} alt="Audit Line" />
              <img src={key} alt="Key Icon" />
              <p>
                Identifying <span style={{ color: "white" }}>key touchpoints</span>.
                <span style={{ display: "block" }}>
                  from awareness to post-purchase.
                </span>
              </p>
            </div>
            <div className="engagement-para">
              <img className="engagement-img" src={auditline} alt="Audit Line" />
              <img src={engagement} alt="Engagement Icon" />
              <p>
                Understand demographics, behaviour, and goals for
                <span style={{ color: "white" }}> personalised engagement.</span>
              </p>
            </div>
            <div className="map-para">
              <img className="map-img" src={auditline} alt="Audit Line" />
              <img src={map} alt="Map Icon" />
              <p>
                <span style={{ color: "white" }}>Map emotional </span> stages
                at each customer interaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BybAudit;
